import React from "react";
import { HiMagnifyingGlass } from "react-icons/hi2";

const Search = ({
  onSubmit,
  onChange,
  keyword,
  onResetFilter,
  handleSearch,
  placeholder
}) => {
  return (
    <form onSubmit={onSubmit} className="flex">
      <div className="relative">
        <input
          type="text"
          className="w-[220px] text-black border-l border-t border-b border-button-grey rounded-l-[4px] px-2 py-1.5 focus:outline-0"
          placeholder={placeholder}
          onChange={onChange}
          value={keyword}
        />
        <div
          onClick={onResetFilter}
          className={`text-[#3E6AB1] font-bold cursor-pointer absolute top-1/2 right-2 transform -translate-x-1/2 -translate-y-1/2 ${
            keyword?.length ? "block" : "hidden"
          }`}
        >
          X
        </div>
      </div>
      <button
        type="submit"
        className="cursor-pointer bg-[#19459f] px-2 py-1 border-r border-[#19459f] rounded-r-[4px]"
      >
        <HiMagnifyingGlass
          onClick={handleSearch}
          className="text-white text-[18px] m-auto"
        />
      </button>
    </form>
  );
};

export default Search;
